import {
    useEffect,
    useState,
} from 'react';

import {
    Autocomplete,
    AutocompleteProps,
    Group,
    Text,
} from '@mantine/core';
import {useUsers} from '../hooks/useUsers';
import {FieldProps} from 'formik';
import {User} from '../types';


export const UserEmailsAutocomplete = ({
                                           field,
                                           form: {setFieldValue},
                                           ...rest
                                       }: FieldProps) => {


    const [value, setValue] = useState('');

    const {
        items: users,
    } = useUsers()


    useEffect(() => {
        const record = users.find((record: User) => record.email === field.value);
        if (record) {
            setValue(record.email as string);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally narrow deps: this effect calls setValue, and the full dependency set changes identity every render, which would loop
    }, [users.length]);


    const renderAutocompleteOption: AutocompleteProps['renderOption'] = ({option}) => {
        const record = users.find((record: User) => record.email === option.value);
        return (
            <Group gap="sm">
                <div>
                    <Text size="sm">{record?.email} [ {[record?.givenName, record?.familyName].join(' ')} ]</Text>
                </div>
            </Group>
        )
    };


    const data = users.map((record: User) => {
        return record.email || ''
    });

    const handleChange = (value: string) => {
        setValue(value);

        const record = users.find((record: User) => record.email === value);
        if (record) {
            setFieldValue(field.name, record.email);
        }
    };


    return (
        <Autocomplete
            name={field.name}
            value={value}
            renderOption={renderAutocompleteOption}
            onChange={handleChange}
            data={data}
            placeholder='Select Component'
            {...rest}
        />
    );
};
